const routePaths = {
  dashboard: { path: '/' },
  login: { path: 'login' },
  register: { path: 'register' },
  forgotPassword: { path: 'forgot-password' },
  transcriptVerification: { path: 'transcript-verification' },
};

export default routePaths;
